import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Portal } from 'react-portal-current';
import classNames from 'classnames';

import { overlay, content, modal } from './styles.module.css';

const StyledModal = (props) => {
  const { className, onClose } = props;

  return (
    <div className={modal}>
      <div className={classNames(content, className)}>{props.children}</div>
      <div className={overlay} onClick={() => onClose()} />
    </div>
  );
};

class TheatrePortal extends Component {
  componentDidMount() {
    /*
     Disable body scrollbar to avoid passing scroll event to it
     when the end of modal scrollbar is reached
     */
    document.body.style.overflow = 'hidden';
  }

  componentWillUnmount() {
    document.body.style.overflow = 'auto';
  }

  render() {
    return (
      <Portal>
        <StyledModal
          className={this.props.className}
          onClose={this.props.onClose}
        >
          {this.props.children}
        </StyledModal>
      </Portal>
    );
  }
}

TheatrePortal.defaultProps = {
  onClose: () => {},
  className: '',
};

TheatrePortal.propTypes = {
  children: PropTypes.element.isRequired,
  onClose: PropTypes.func,
  className: PropTypes.string,
};

export default TheatrePortal;
